/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import api from "../../services/api";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { ContainerCheckout } from "./style.js";

import Container from 'react-bootstrap/Container';

import { verifyLogin } from "./../../utils/verifyLogin";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import { Typography } from '@mui/material';

import { formatCurrencyBRL } from "./../../utils/formatCurrencyBRL";
import { getDevice } from "./../../utils/getDevice";

import { useCart } from './../../utils/CartContext';

import ModalAddAddress from './../../components/ModalAddAddress';
import { logCheckoutError } from '../../utils/errorLogger';
import { logoutUser } from '../../utils/logout';

// Importar componentes do stepper
import CheckoutStepper from '../../components/ui/Stepper';
import AddressStep from '../../components/checkout/AddressStep';
import PaymentStep from '../../components/checkout/PaymentStep';
import ShippingStep from '../../components/checkout/ShippingStep';
import SummaryStep from '../../components/checkout/SummaryStep';

const schema = yup.object().shape({
  addressSelected: yup.string().required('Selecione um endereço para entrega!'),
  paymentSelected: yup.string().required('Selecione a forma de pagamento!'),
  dispatchSelected: yup.string().required('Selecione a forma de envio!'),
  observation: yup.string().max(500, 'A observação deve ter no máximo 500 caracteres.'),
});

const steps = [
  { label: 'Endereço de Entrega' },
  { label: 'Forma de Pagamento' },
  { label: 'Forma de Envio' },
  { label: 'Resumo do Pedido' }
];

const CheckoutV2 = () => {

  document.title = "Elite Comandos - Finalizar Pedido"

  const { setCartLength } = useCart();
  const navigate = useNavigate();

  // Estados do stepper
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);

  const [isSending, setIsSending] = useState(false);
  const [idDM001, setIdDM001] = useState(0);
  const [mailClient, setMailClient] = useState(0);
  const [cdClient, setCdClient] = useState(0);
  const [addressSelected, setAddressSelected] = useState();
  const [paymentSelected, setPaymentSelected] = useState();
  const [dispatchSelected, setDispatchSelected] = useState();
  const [addressList, setAddressList] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [dispatchList, setDispatchList] = useState([]);

  const [prodListCart, setProdListCart] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [vlMinOrder, setVlMinOrder] = useState(0);
  const [handleModalAddAddress, setHandleModalAddAddress] = useState(false);

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      addressSelected: '',
      paymentSelected: '',
      dispatchSelected: '',
      observation: '',
    },
  });

  useEffect(() => {
    const fetchClientData = async () => {
      const timeout = 5000; // 5 seconds timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout')), timeout)
      );

      try {
        const lsClientPromise = new Promise((resolve) => {
          const lsClient = JSON.parse(localStorage.getItem('userDataLogin'));
          resolve(lsClient);
        });

        const lsClient = await Promise.race([lsClientPromise, timeoutPromise]);

        if (lsClient?.ID_DM001) {
          setIdDM001(lsClient.ID_DM001);
          setCdClient(lsClient.CD_CLIENTE);
          setMailClient(lsClient.DS_EMAIL);
        } else {
          throw new Error('Client data not found');
        }
      } catch (error) {
        toast.error('Erro ao buscar dados do cliente. Tente novamente mais tarde.');
        console.error(error);
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          error.message || 'Erro desconhecido ao buscar dados do cliente',
          'Dados do Cliente',
          {
            errorDetails: `Erro ao buscar dados do cliente: ${error.message}`,
            clientId: 'N/A'
          }
        );
        
        navigate(`/`);
      }
    };

    if (!verifyLogin()) {
      navigate(`/`);
    } else {
      fetchClientData();
    }
  }, []);

  useEffect(() => {
    setValue('addressSelected', addressSelected);
  }, [addressSelected, setValue]);

  useEffect(() => {
    setValue('paymentSelected', paymentSelected);
  }, [paymentSelected, setValue]);

  useEffect(() => {
    setValue('dispatchSelected', dispatchSelected);
  }, [dispatchSelected, setValue]);

  useEffect(() => {
    const fetchOrdersFilter = async () => {
      try {
        const dataOrdersFilter = { ID_DM001: idDM001 };
        const ordersResponse = await api.post("get_orders_filter", dataOrdersFilter);
        const filteredResponseData = ordersResponse.data.filter((item) => item.IN_SITUACAO !== "3");

        const dataFilterParm = {
          DS_KEY_PARAMETRO: filteredResponseData.length < 2 ? 'VL_PEDIDO_MINIMO_1' : 'VL_PEDIDO_MINIMO_2',
        };

        const parmsResponse = await api.post("filter_parms", dataFilterParm);
        setVlMinOrder(parmsResponse?.data[0]?.DS_VALOR_PARAMETRO || 0);


      } catch (err) {
        toast.error('Erro ao carregar valor mínimo do pedido. Fazendo logout...');
        console.error(err);
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          err.message || 'Erro desconhecido ao carregar valor mínimo do pedido',
          'Valor Mínimo do Pedido',
          {
            errorDetails: `Erro ao buscar parâmetros: ${err.response?.data?.message || err.message}`,
            clientId: idDM001
          }
        );

        // Forçar logout e redirecionar para login
        setTimeout(() => {
          logoutUser();
        }, 2000); // Aguarda 2 segundos para mostrar a mensagem de erro
      }
    };

    if (idDM001) {
      fetchOrdersFilter();
    }
  }, [idDM001]);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const paymentsResponse = await api.get("get_all_payments");
        setPaymentList(paymentsResponse?.data);
      } catch (err) {
        toast.error('Erro ao carregar formas de pagamento. Tente novamente mais tarde!');
        console.error(err);
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          err.message || 'Erro desconhecido ao carregar formas de pagamento',
          'Formas de Pagamento',
          {
            errorDetails: `Erro ao buscar formas de pagamento: ${err.response?.data?.message || err.message}`,
            clientId: idDM001
          }
        );
      }
    };

    fetchPaymentMethods();
  }, []);

  useEffect(() => {
    const fetchDispatchMethods = async () => {
      try {
        const dispatchResponse = await api.get("get_all_dispatchs");
        setDispatchList(dispatchResponse?.data);
      } catch (err) {
        toast.error('Erro ao carregar formas de envio. Tente novamente mais tarde!');
        console.error(err);
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          err.message || 'Erro desconhecido ao carregar formas de envio',
          'Formas de Envio',
          {
            errorDetails: `Erro ao buscar formas de envio: ${err.response?.data?.message || err.message}`,
            clientId: idDM001
          }
        );
      }
    };

    fetchDispatchMethods();
  }, []);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const addressResponse = await api.get(`get_all_address/${idDM001}`);
        const addresses = addressResponse?.data || [];

        // Sort addresses: default addresses first (IN_PADRAO = "S"), then by oldest ID (ID_DM002)
        const sortedAddresses = addresses.sort((a, b) => {
          // First priority: default addresses
          if (a.IN_PADRAO === "S" && b.IN_PADRAO !== "S") return -1;
          if (a.IN_PADRAO !== "S" && b.IN_PADRAO === "S") return 1;
          
          // Second priority: oldest address (smaller ID_DM002)
          return parseInt(a.ID_DM002) - parseInt(b.ID_DM002);
        });

        setAddressList(sortedAddresses);

        // Select the first address from sorted list (default or oldest)
        if (sortedAddresses.length > 0) {
          setAddressSelected(sortedAddresses[0].ID_DM002);
        }

        // Enviar log de sucesso para testar o sistema
        await logCheckoutError(
          `Endereços carregados com sucesso. Total: ${addresses.length} endereços`,
          'Endereços do Cliente - Sucesso',
          {
            errorDetails: `Sucesso ao buscar endereços: ${addresses.length} endereços encontrados`,
            clientId: idDM001
          }
        );

      } catch (err) {
        toast.error('Erro ao carregar endereços. Tente novamente mais tarde!');
        console.error(err);
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          err.message || 'Erro desconhecido ao carregar endereços',
          'Endereços do Cliente',
          {
            errorDetails: `Erro ao buscar endereços: ${err.response?.data?.message || err.message}`,
            clientId: idDM001
          }
        );

        // Forçar logout e redirecionar para login
        setTimeout(() => {
          logoutUser();
        }, 2000); // Aguarda 2 segundos para mostrar a mensagem de erro
      }
    };

    if (idDM001) {
      fetchAddresses();
    }
  }, [idDM001]);

  useEffect(() => {
    if (!verifyLogin()) {
      navigate(`/`);
    }

    const prodList = JSON.parse(localStorage.getItem('productCart'));
    if (prodList) {
      setProdListCart(prodList)
    }

  }, []);

  useEffect(() => {
    api
      .get("get_all_sizes")
      .then((response) => {
        setSizeList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    api
      .get("get_all_colors")
      .then((response) => {
        setColorList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const findSizeById = (id) => {
    const size = sizeList.find((size) => size.ID_DM004 === parseInt(id));
    return size ? size.SG_TAMANHO : "";
  };

  const findColorById = (id) => {
    const color = colorList.find((color) => color.ID_DM003 === parseInt(id));
    return color ? color.NM_COR : "";
  };

  const calculateTotalPrice = (quantities, price) => {
    const totalQuantities = Object.values(quantities).reduce((acc, curr) => acc + curr, 0);
    return totalQuantities * price;
  };

  const orderCartFormatter = () => {
    const remodeledProdListCart = prodListCart.map((product) => {
      const { quantities, ...rest } = product;
      const newQuantities = Object.entries(quantities).reduce((acc, [key, value]) => {
        const [colorId, sizeId] = key.split('-');
        if (!acc[colorId]) {
          acc[colorId] = {};
        }
        if (!acc[colorId][sizeId]) {
          acc[colorId][sizeId] = {};
        }
        acc[colorId][sizeId][product.laterality] = value;
        return acc;
      }, {});
      return { ...rest, quantities: newQuantities };
    });

    const groupedProducts = remodeledProdListCart.reduce((acc, product) => {
      const { id } = product;
      if (!acc[id]) {
        acc[id] = { ...product };
      } else {
        Object.keys(product.quantities).forEach((colorId) => {
          if (!acc[id].quantities[colorId]) {
            acc[id].quantities[colorId] = { ...product.quantities[colorId] };
          } else {
            Object.keys(product.quantities[colorId]).forEach((sizeId) => {
              if (!acc[id].quantities[colorId][sizeId]) {
                acc[id].quantities[colorId][sizeId] = { ...product.quantities[colorId][sizeId] };
              } else {
                Object.keys(product.quantities[colorId][sizeId]).forEach((laterality) => {
                  if (!acc[id].quantities[colorId][sizeId][laterality]) {
                    acc[id].quantities[colorId][sizeId][laterality] = product.quantities[colorId][sizeId][laterality];
                  } else {
                    acc[id].quantities[colorId][sizeId][laterality] += product.quantities[colorId][sizeId][laterality];
                  }
                });
              }
            });
          }
        });
      }
      return acc;
    }, {});

    return Object.values(groupedProducts);
  };

  const calculateTotalQuantity = (quantities) => {
    const totalQuantities = Object.values(quantities).reduce((acc, curr) => acc + curr, 0);
    return totalQuantities;
  };

  const grandTotal = prodListCart.reduce((acc, prod) => acc + calculateTotalPrice(prod.quantities, prod.price), 0);

  useEffect(() => {
    if (vlMinOrder > 0 && vlMinOrder > grandTotal) {
      toast.warning(`Pedido mínimo de: ${formatCurrencyBRL(vlMinOrder)}`);
      toast.warning(`Redirecionando para o carrinho...`);
      setTimeout(() => {
        navigate('/cart');
      }, 5000);
    }
  }, [vlMinOrder, grandTotal]);

  const addNewAddressOpen = useCallback(() => {
    setHandleModalAddAddress(true);
  },
    [handleModalAddAddress]
  );

  const onCloseModalAddAddress = () => {
    setHandleModalAddAddress(false);
  };

  const addNewAddress = (address) => {
    api
      .post("create_client_address", address)
      .then((response) => {
        if (response?.data) {
          if (response?.data?.success) {
            setAddressList((prevState) => [
              ...prevState,
              response.data.address,
            ]);
            setAddressSelected(response?.data?.address?.ID_DM002);
            toast.success(response?.data?.message)
            setHandleModalAddAddress(false);
          } else {
            toast.warning(response.data.message)
          }
        } else {
          toast.error(response.data.message)
        }
      })
      .catch((err) => {
        toast.error('Erro ao cadastrar endereço, entre em contato com a loja!')
        console.log(err)
      });
  }

  const getAddressClient = async () => {
    try {
      const response = await api.get(`get_all_address/${idDM001}`);
      const addresses = response.data || [];
      
      // Sort addresses: default addresses first (IN_PADRAO = "S"), then by oldest ID (ID_DM002)
      const sortedAddresses = addresses.sort((a, b) => {
        // First priority: default addresses
        if (a.IN_PADRAO === "S" && b.IN_PADRAO !== "S") return -1;
        if (a.IN_PADRAO !== "S" && b.IN_PADRAO === "S") return 1;
        
        // Second priority: oldest address (smaller ID_DM002)
        return parseInt(a.ID_DM002) - parseInt(b.ID_DM002);
      });

      setAddressList(sortedAddresses);
      
      // If no address is currently selected, select the first one from sorted list
      if (!addressSelected && sortedAddresses.length > 0) {
        setAddressSelected(sortedAddresses[0].ID_DM002);
      }
      
      toast.success('Lista de endereços atualizada!');
    } catch (err) {
      toast.error('Erro ao atualizar lista de endereços.');
      console.error(err);
      
      // Enviar log de erro para o backend
      await logCheckoutError(
        err.message || 'Erro desconhecido ao atualizar lista de endereços',
        'Atualização de Endereços',
        {
          errorDetails: `Erro ao atualizar endereços: ${err.response?.data?.message || err.message}`,
          clientId: idDM001
        }
      );
    }
  };

  const onSubmit = (data) => {
    const { addressSelected, paymentSelected, dispatchSelected, observation } = data;

    const DataOrder = {
      clientId: idDM001,
      cdClient: cdClient,
      addressId: addressSelected,
      mailClient: mailClient,
      DS_OBSERVACAO: observation,
      DS_FORMA_PAGAMENTO: paymentSelected,
      DS_FORMA_ENVIO: dispatchSelected,
      NM_DISPOSITIVO: getDevice(),
      products: orderCartFormatter(),
    };

    setIsSending(true);
    api.post("create_order", DataOrder)
      .then((response) => {
        if (response.data.success) {
          localStorage.removeItem('productCart');
          setCartLength(0);
          setProdListCart([]);
          navigate('/orders');
        } else {
          toast.warning(response.data.message);
        }
      })
      .catch(async (err) => {
        console.error(err);
        toast.error(err.response?.data?.message || "Erro desconhecido no servidor.");
        
        // Enviar log de erro para o backend
        await logCheckoutError(
          err.message || 'Erro desconhecido ao criar pedido',
          'Criação de Pedido',
          {
            errorDetails: `Erro ao criar pedido: ${err.response?.data?.message || err.message}`,
            clientId: idDM001
          }
        );
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  // Funções do stepper
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      // Marcar etapa atual como completa
      if (!completedSteps.includes(activeStep)) {
        setCompletedSteps([...completedSteps, activeStep]);
      }
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleStepClick = (stepIndex) => {
    // Permitir navegação apenas para etapas já visitadas ou a próxima válida
    if (stepIndex <= Math.max(...completedSteps, -1) + 1) {
      setActiveStep(stepIndex);
    }
  };

  const handleEditAddress = () => {
    setActiveStep(0);
  };

  const handleEditPayment = () => {
    setActiveStep(1);
  };

  const handleEditShipping = () => {
    setActiveStep(2);
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <AddressStep
            addressList={addressList}
            addressSelected={addressSelected}
            setAddressSelected={setAddressSelected}
            errors={errors}
            control={control}
            Controller={Controller}
            addNewAddressOpen={addNewAddressOpen}
            getAddressClient={getAddressClient}
            onNext={handleNext}
          />
        );
      case 1:
        return (
          <PaymentStep
            paymentList={paymentList}
            paymentSelected={paymentSelected}
            setPaymentSelected={setPaymentSelected}
            errors={errors}
            control={control}
            Controller={Controller}
            selectedAddress={addressSelected}
            addressList={addressList}
            onNext={handleNext}
            onBack={handleBack}
            onEditAddress={handleEditAddress}
          />
        );
      case 2:
        return (
          <ShippingStep
            dispatchList={dispatchList}
            dispatchSelected={dispatchSelected}
            setDispatchSelected={setDispatchSelected}
            errors={errors}
            control={control}
            Controller={Controller}
            selectedAddress={addressSelected}
            selectedPayment={paymentSelected}
            addressList={addressList}
            paymentList={paymentList}
            onNext={handleNext}
            onBack={handleBack}
            onEditAddress={handleEditAddress}
            onEditPayment={handleEditPayment}
          />
        );
      case 3:
        return (
          <SummaryStep
            selectedAddress={addressSelected}
            selectedPayment={paymentSelected}
            selectedDispatch={dispatchSelected}
            addressList={addressList}
            prodListCart={prodListCart}
            grandTotal={grandTotal}
            vlMinOrder={vlMinOrder}
            errors={errors}
            control={control}
            Controller={Controller}
            isSending={isSending}
            onBack={handleBack}
            onEditAddress={handleEditAddress}
            onEditPayment={handleEditPayment}
            onEditShipping={handleEditShipping}
            onSubmit={handleSubmit(onSubmit)}
            findColorById={findColorById}
            findSizeById={findSizeById}
            calculateTotalPrice={calculateTotalPrice}
            calculateTotalQuantity={calculateTotalQuantity}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <ContainerCheckout>
        <Container className="conShadown">
          <Typography variant="h4" component="h1" gutterBottom>
            Finalizar Pedido
          </Typography>
          
          <CheckoutStepper
            activeStep={activeStep}
            steps={steps}
            onStepClick={handleStepClick}
            completedSteps={completedSteps}
          />
          
          {renderStepContent()}
          
        </Container>
      </ContainerCheckout>
      
      <ToastContainer />

      <ModalAddAddress
        modalStatus={handleModalAddAddress}
        closeModelFunction={onCloseModalAddAddress}
        addNewAddressFunction={addNewAddress}
      />
      <Footer />
    </>
  );
}

export default CheckoutV2;
